import * as types from '../../actions/types';

const initialState = {

}

export default function ciup (state = initialState, action) {
  switch (action.type) {
    case types.SET_DASHBOARD_CIUP_DATA:
      return {...state, ...action.payload};

    default:
      return state;
  }
}
